
const glideClass = 'carousel';

const glideConfig = {
  classes: {
    slider: glideClass + '--slider',
    carousel: glideClass + '--carousel',
    swipeable: glideClass + '--swipeable',
    dragging: glideClass + '--dragging',
    cloneSlide: glideClass + '__slide--clone',
    activeSlide: glideClass + '__slide--active',
    disabledArrow: glideClass + '__arrow--disabled',
    direction: {
      ltr: glideClass + '--ltr',
      rtl: glideClass + '--rtl',
    },
    nav: {
      active: glideClass + '__bullet--active',
    },
  },
  animationDuration: 500,
  animationTimingFunc: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
}

export default glideConfig;
